import { useQuery } from '@tanstack/react-query';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';
import { AttendanceCheckApi } from 'api/ApiHelper';

export const useGetAttendanceCheckNotiQuery = () =>
  useQuery({ queryKey: activityPointQueryKey.attendanceCheckNoti(), queryFn: () => AttendanceCheckApi.getNoti() });
